import { Flex } from "antd";
import React, { FunctionComponent } from "react";
import { Icon } from "@mui/material";

import { Serie } from "../types/Serie";
import DefaultCoverV2 from "../cover/DefaultCoverV2";
import { Category } from "../types/Category";
import { useIsOverflow } from "../utils/useIsOverflow";

interface HorizontalListProps {
  cat: Category;
  onClickSerie: (serie: Serie) => void;
  index: number;
}

const HorizontalList: FunctionComponent<HorizontalListProps> = (
  props: HorizontalListProps
) => {
  const { cat, onClickSerie, index } = props;

  const ref = React.useRef<any>();
  const isOverflow = useIsOverflow(ref);
  const [addLeftScroll, setAddLeftScroll] = React.useState(false);
  const [addRightScroll, setAddRightScroll] = React.useState(true);

  const scroll = (direction: "left" | "right" | "scroll") => {
    if (direction === "scroll") {
      const currentScrollLeft = Math.abs(
        ref.current.scrollWidth -
          (ref.current.scrollLeft + ref.current.clientWidth)
      );

      if (ref.current.scrollLeft > 20) setAddLeftScroll(true);
      if (currentScrollLeft <= 0) setAddRightScroll(false);

      if (ref.current.scrollLeft <= 20) setAddLeftScroll(false);
      if (currentScrollLeft > 0) setAddRightScroll(true);
      return;
    }

    const isRight = direction === "right";
    if (ref.current) {
      ref.current.scrollTo({
        left: ref.current.scrollLeft + 200 * (isRight ? 1 : -1),
        behavior: "smooth",
      });
    }
  };

  return (
    <div style={{ marginBottom: 30 }} key={index}>
      <div className="serie-title" style={{ fontSize: 24, marginLeft: 20 }}>
        {cat.name}
      </div>
      <div style={{ flex: 1, display: "flex", position: "relative" }}>
        <Flex
          ref={ref}
          wrap="nowrap"
          style={{
            overflow: "scroll",
            paddingLeft: 15,
            scrollbarWidth: "none",
          }}
          onScroll={() => scroll("scroll")}
        >
          {cat.content.map((s: Serie) => {
            return (
              <DefaultCoverV2
                onClickCover={() => onClickSerie(s)}
                key={s.uid}
                serie={s as Serie}
              />
            );
          })}
        </Flex>
        {addLeftScroll && (
          <Flex
            style={{
              position: "absolute",
              left: 0,
              top: 10,
              bottom: 0,
              backgroundColor: "rgba(18,13,53,0.75)",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
            }}
            onClick={() => scroll("left")}
          >
            <Icon sx={{ fontSize: 50, color: "white" }}>chevron_left</Icon>
          </Flex>
        )}
        {isOverflow && addRightScroll && (
          <Flex
            style={{
              position: "absolute",
              right: 0,
              top: 10,
              bottom: 0,
              backgroundColor: "rgba(18,13,53,0.75)",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
            }}
            onClick={() => scroll("right")}
          >
            <Icon sx={{ fontSize: 50, color: "white" }}>chevron_right</Icon>
          </Flex>
        )}
      </div>
    </div>
  );
};

export default HorizontalList;
